import React from 'react'
import { useSelector } from 'react-redux'
import { selectGeoentities, selectIsWaitingForRequestedGeoentities } from '../../store/geoentity/geoentity.selectors'
import GeoentityList from '../geoentity/GeoentityList'
import { withFrenchSite } from '../i18n/i18nSite'
import s from './GeoentitiesAtAddress.less'

function GeoentitiesAtAddress() {
  const isWaitingForGeoentities = useSelector(selectIsWaitingForRequestedGeoentities)
  const pois = useSelector(selectGeoentities)

  if (!isWaitingForGeoentities && pois.length === 0) return <></>

  return (
    <div className={s.bloc}>
      <div className={s.title}>A cette adresse</div>
      <GeoentityList />
    </div>
  )
}

export default withFrenchSite(GeoentitiesAtAddress)
